import * as React from "react";
import { useQuery } from "@apollo/client";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { meQuery } from "../../Me";
import { MeQueryQuery } from "../../../schemaTypes";

export const OnboardedRoute: React.FC = () => {
  const { data, loading, error } = useQuery<MeQueryQuery>(meQuery);
  const location = useLocation();
  const next = location.pathname + location.search + location.hash;

  if (loading) return <div>Loading...</div>;
  if (error) return <Navigate to="/login" replace state={{ next }} />;

  if (!data?.me) {
    return <Navigate to="/login" replace state={{ next }} />;
  }

  if (data?.me.onboarding?.status === "Onboarded") {
    return <Navigate to="/home" replace />;
  }

  return <Outlet />;
};